


import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch } from "react-redux";
import { shallowEqual, useSelector } from "react-redux";
import { FormattedMessage } from 'react-intl';
import * as actions from "../../../../../app/actions/generalActions";
import { FieldFeedbackLabel, Select } from '../../../../_partials/controls';
import { useIntl } from 'react-intl';
import { useFilterObjectsUIContext } from '../pages/FilterObjectsUIContext';
import { useFormikContext } from 'formik';

export const SelectObjectsField = ({
  api,
  reduxState,
  sname,
  keyFieldName,
  valueFieldNames,
  label,
  functionName,
  useInFilter = false,
  ...props
}) => {
  const objectsUIContext = useFilterObjectsUIContext();
  const objectsUIProps = useMemo(() => {
    return {
      queryParams: objectsUIContext.queryParams,
      setQueryParams: objectsUIContext.setQueryParams,
    };
  }, [objectsUIContext]);

  const { currentState } = useSelector(
    (state) => ({ currentState: state[reduxState] }),
    shallowEqual
  );
  const { entities, name } = currentState;

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.fetchSelectObjects(api, name, objectsUIProps.queryParams, functionName));
  }, [objectsUIProps.queryParams, dispatch]);

  const intl = useIntl();
  return (
    <>
      <Select name={sname} label={label} {...props}>
        {name && name === "filterAnswers" && (
          <option key={0} value={0}>
            بدون پاسخ
          </option>
        )}
        {name !== "filterAnswers" && useInFilter && (
          <option key={0} value={0}>
            {intl.formatMessage({ id: "SELECT.ALL" })}
          </option>
        )}
        {name !== "filterAnswers" && !useInFilter && (
          <option key={0} value={0}>
            {intl.formatMessage({ id: "SELECT.ONE" })}
          </option>
        )}

        {entities &&
          entities.map((entity, index) => {
            const valueField = valueFieldNames
              .map((val) => entity[val])
              .join(" ");

            return (
              <option key={entity[keyFieldName]} value={entity[keyFieldName]}>
                {valueField}
              </option>
            );
          })}
      </Select>
    </>
  )
}

SelectObjectsField.defaultProps = {
  keyFieldName: "id",
  valueFieldNames: ["title"],
};